const createIterator = (prefix: string) => {
  let currentId = 1;
  return (): string => `${prefix}-${currentId++}`;
};

export const nextPopoutId = createIterator('overlay-popout');
